import { TimeLineClusterItem, TimelineItem } from '@bringg-frontend/bringg-timeline';
import { Run, Task } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

import { getEtaToHome } from '../details-table/cell-renderers/eta-base-cell';

import rowStyles from './tasks-timeline.module.scss';

const addMarginToZoom = (startEnd: { start: number; end: number }) => {
	const { start, end } = startEnd;
	const interval = end - start;

	// apply a margin of 1% left and right of the data
	return { start: start - interval * 0.01, end: end + interval * 0.01 };
};

const runRangeItem = (run: Run): TimelineItem | null => {
	const { id, started_at, ended_at, scheduled_start_time, scheduled_end_time } = run;
	const eta_to_home = getEtaToHome(id);

	let start = started_at,
		end = ended_at;

	if (!started_at) {
		start = scheduled_start_time;
		end = scheduled_end_time;
	} else if (!ended_at) {
		end = eta_to_home;
	}

	if (!start || !end) return null;

	return {
		id: `range-${id}`,
		rowId: id,
		backgroundItem: true,
		className: rowStyles.range,
		clickable: false,
		start: new Date(start).valueOf(),
		end: new Date(end).valueOf()
	};
};

const sortByPriority = (taskA: Task, taskB: Task) => taskA.priority - taskB.priority;

const getFirstTaskFromClusterItem = (item: TimeLineClusterItem) => {
	return item.items
		.map(timelineItem => getRootEnv().dashboardSdk.sdk.v2.tasks.get(Number(timelineItem.id)))
		.sort(sortByPriority)[0];
};

export const timelineProvider = {
	addMarginToZoom,
	getRangeItem: runRangeItem,
	getFirstTaskFromClusterItem,
	sortByPriority
};
